import { CLEAR_CURRENT_ASSESSMENT, UPDATE_CURRENT_ASSESSMENT, SAVE_ASSESSMENT_INFO, SAVE_CURRENT_ANSWER, SAVE_NOTES, TOGGLE_FLAG_CURRENT_ANSWER, NAVIGATE_TO } from '../actions/assessmentsActionTypes';

const initialState = {
  answers: {},
  facilitators: [],
  participants: [],
  wastageCalculator: [],
};

export default function currentAssessment(state = initialState, action) {
  switch (action.type) {
    case SAVE_CURRENT_ANSWER:
      return {
        ...state,
        lastQuestionIndex: Math.max(state.lastQuestionIndex, action.index),
        answers: {
          ...state.answers,
          [action.id]: {
            ...state.answers[action.id],
            ...action.answer,
            parts: state.answers[action.id]
              ? {
                ...state.answers[action.id].parts,
                ...action.answer.parts,
              } : action.answer.parts,
          },
        },
      };
    case TOGGLE_FLAG_CURRENT_ANSWER:
      return {
        ...state,
        lastQuestionIndex: Math.max(state.lastQuestionIndex, action.index),
        answers: {
          ...state.answers,
          [action.id]: {
            parts: {}, // default fallback
            ...state.answers[action.id],
            flagged: state.answers[action.id]
              ? !state.answers[action.id].flagged
              : true,
          },
        },
      };
    case SAVE_NOTES:
      return {
        ...state,
        lastQuestionIndex: Math.max(state.lastQuestionIndex, action.index),
        answers: {
          ...state.answers,
          [action.id]: {
            parts: {}, // default fallback
            ...state.answers[action.id],
            ...action.notes,
          },
        },
      };
    case NAVIGATE_TO:
      return {
        ...state,
        page: action.page,
        currentQuestionIndex: action.questionIndex,
      };
    case SAVE_ASSESSMENT_INFO:
      return {
        ...state,
        ...action.data,
      };
    case UPDATE_CURRENT_ASSESSMENT:
      if (state.id !== action.assessment.id) {
        // These are different assessments; use the new one
        return {
          ...initialState,
          ...action.assessment,
        };
      }
      // Otherwise let's use the current state and just update some metadata
      return {
        ...state,
        lastEditedBy: action.assessment.lastEditedBy,
        updatedAt: action.assessment.updatedAt,
      };
    case CLEAR_CURRENT_ASSESSMENT:
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/currentAssessmentReducer.js